const STORAGE_KEY = 'superoti.warehouse.device'

export type WarehouseDeviceBinding = {
  deviceId: string
  deviceUid: string
  deviceName: string
  brandId: string
  warehouseId: string
  warehouseCode?: string
  warehouseName: string
  deviceType: 'warehouse_tablet'
  activatedAt: string
}

export function getWarehouseDevice(): WarehouseDeviceBinding | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as WarehouseDeviceBinding
  } catch {
    return null
  }
}

export function setWarehouseDevice(binding: WarehouseDeviceBinding): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(binding))
}

export function clearWarehouseDevice(): void {
  localStorage.removeItem(STORAGE_KEY)
}

export function hasWarehouseDevice(): boolean {
  return getWarehouseDevice() !== null
}
